var _defs, _path, _rect, _path2, _path3, _rect2, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 133.3 116.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#radial-gradient);isolation:isolate;opacity:.05;}.cls-3{fill:#fff;}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-2);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 33.3,
    y1: 2392.4,
    x2: 133.4,
    y2: 2392.4,
    gradientTransform: "translate(0 -2334)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffca00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 33.3,
    y1: 2377.8,
    x2: 133.3,
    y2: 2377.8,
    gradientTransform: "translate(0 -2334)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d3ad4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30b6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 33.3,
    y1: 2348.6,
    x2: 133.3,
    y2: 2348.6,
    gradientTransform: "translate(0 -2334)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#30b6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d3ad4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -12846.24,
    y1: -1535.48,
    x2: -12746.14,
    y2: -1535.48,
    gradientTransform: "translate(-12712.84 -1433.38) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 2406.9,
    y2: 2406.9,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 34.11,
    cy: 2392.69,
    fx: 34.11,
    fy: 2392.69,
    r: 49.2,
    gradientTransform: "translate(0 -2334)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0,
    y1: 2392.3,
    x2: 66.6,
    y2: 2392.3,
    xlinkHref: "#linear-gradient-3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.2,0H37.5C35.2,0,33.3,1.9,33.3,4.2V112.6c0,2.3,1.9,4.2,4.2,4.2h91.7c2.3,0,4.2-1.9,4.2-4.2V4.2C133.3,1.9,131.5,0,129.2,0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 33.3,
    y: 29.2,
    width: 100,
    height: 29.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M133.3,29.2V4.2C133.3,1.9,131.4,0,129.1,0H37.5C35.2,0,33.3,1.9,33.3,4.2V29.2h100Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M33.3,87.5v25c0,2.3,1.9,4.2,4.2,4.2h91.7c2.3,0,4.2-1.9,4.2-4.2v-25H33.3Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 33.3,
    y: 58.3,
    width: 100,
    height: 29.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.3,108.3h0c27.6,0,50-22.4,50-50h0c0-27.6-22.4-50-50-50h0s0,100,0,100Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M33.3,25h0C14.9,25,0,39.9,0,58.3H0c0,18.4,14.9,33.3,33.3,33.3h0c18.4,0,33.3-14.9,33.3-33.3h0c.1-18.4-14.9-33.3-33.3-33.3Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33,75.5c-2.7,0-5.2-.4-7.7-1.1-2.4-.7-4.4-1.6-5.9-2.8l2.6-5.8c1.4,1,3.1,1.9,5.1,2.5,2,.7,3.9,1,5.9,1,1.5,0,2.8-.1,3.7-.5,.9-.3,1.6-.7,2.1-1.3,.4-.5,.7-1.2,.7-1.9,0-.9-.3-1.6-1-2.1s-1.6-1-2.8-1.3c-1.1-.3-2.4-.7-3.8-1-1.4-.3-2.8-.7-4.1-1.1-1.4-.4-2.6-1-3.8-1.7-1.1-.7-2.1-1.6-2.8-2.8-.7-1.1-1.1-2.6-1.1-4.4,0-1.9,.5-3.6,1.5-5.2,1-1.6,2.6-2.8,4.7-3.8,2.1-.9,4.7-1.4,7.8-1.4,2.1,0,4.2,.2,6.2,.7s3.8,1.2,5.4,2.2l-2.4,5.9c-1.6-.9-3.1-1.5-4.7-2-1.6-.4-3.1-.6-4.6-.6s-2.7,.2-3.7,.5-1.6,.8-2,1.4c-.4,.6-.6,1.2-.6,1.9,0,.9,.3,1.5,1,2.1,.7,.5,1.6,.9,2.8,1.3,1.1,.3,2.4,.6,3.8,1,1.4,.3,2.8,.7,4.1,1.1,1.4,.4,2.6,1,3.8,1.7,1.1,.7,2.1,1.6,2.8,2.8,.7,1.1,1.1,2.6,1.1,4.3,0,1.9-.5,3.6-1.6,5.1-1,1.6-2.6,2.8-4.7,3.8-2,1.1-4.6,1.5-7.8,1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.33f6571a88f8ddcc48ab47ff5f9abd2f.svg";
export { ForwardRef as ReactComponent };